export const GET_THERMOBOX_REPORT_INFO = 'thermoboxes-reports-modal/GET_THERMOBOX_REPORT_INFO';
export const getThermoboxReportInfoAction = payload => ({
	type: GET_THERMOBOX_REPORT_INFO,
	payload,
});

export const SET_THERMOBOX_REPORT_INFO = 'thermoboxes-reports-modal/SET_THERMOBOX_REPORT_INFO';
export const setThermoboxReportInfoAction = payload => ({
	type: SET_THERMOBOX_REPORT_INFO,
	payload,
});

export const SET_IS_THERMOBOX_REPORT_INFO_LOADING = 'thermoboxes-reports-modal/SET_IS_THERMOBOX_REPORT_INFO_LOADING';
export const setIsThermoboxReportInfoLoadingAction = payload => ({
	type: SET_IS_THERMOBOX_REPORT_INFO_LOADING,
	payload,
});

export const CREATE_THERMOBOX_REPORT = 'thermoboxes-reports-modal/CREATE_THERMOBOX_REPORT';
export const createThermoboxReportAction = payload => ({
	type: CREATE_THERMOBOX_REPORT,
	payload,
});

export const SET_IS_THERMOBOX_REPORT_CREATING = 'thermoboxes-reports-modal/SET_IS_THERMOBOX_REPORT_CREATING';
export const setIsThermoboxReportCreatingAction = payload => ({
	type: SET_IS_THERMOBOX_REPORT_CREATING,
	payload,
});

export const UPDATE_THERMOBOX_REPORT = 'thermoboxes-reports-modal/UPDATE_THERMOBOX_REPORT';
export const updateThermoboxReportAction = payload => ({
	type: UPDATE_THERMOBOX_REPORT,
	payload,
});

export const SET_IS_THERMOBOX_REPORT_UPDATING = 'thermoboxes-reports-modal/SET_IS_THERMOBOX_REPORT_UPDATING';
export const setIsThermoboxReportUpdatingAction = payload => ({
	type: SET_IS_THERMOBOX_REPORT_UPDATING,
	payload,
});

export const DELETE_THERMOBOX_REPORT = 'thermoboxes-reports-modal/DELETE_THERMOBOX_REPORT';
export const deleteThermoboxReportAction = payload => ({
	type: DELETE_THERMOBOX_REPORT,
	payload,
});

export const SET_IS_THERMOBOX_REPORT_DELETING = 'thermoboxes-reports-modal/SET_IS_THERMOBOX_REPORT_DELETING';
export const setIsThermoboxReportDeletingAction = payload => ({
	type: SET_IS_THERMOBOX_REPORT_DELETING,
	payload,
});

export const GET_THERMOBOXES = 'thermoboxes-reports-modal/GET_THERMOBOXES';
export const getThermoboxesAction = () => ({
	type: GET_THERMOBOXES,
});

export const SET_THERMOBOXES = 'thermoboxes-reports-modal/SET_THERMOBOXES';
export const setThermoboxesAction = payload => ({
	type: SET_THERMOBOXES,
	payload,
});

export const SET_IS_THERMOBOXES_LOADING = 'thermoboxes-reports-modal/SET_IS_THERMOBOXES_LOADING';
export const setIsThermoboxesLoadingAction = payload => ({
	type: SET_IS_THERMOBOXES_LOADING,
	payload,
});

export const GET_MODES = 'thermoboxes-reports-modal/GET_MODES';
export const getModesAction = () => ({
	type: GET_MODES,
});

export const SET_MODES = 'thermoboxes-reports-modal/SET_MODES';
export const setModesAction = payload => ({
	type: SET_MODES,
	payload,
});

export const SET_IS_MODES_LOADING = 'thermoboxes-reports-modal/SET_IS_MODES_LOADING';
export const setIsModesLoadingAction = payload => ({
	type: SET_IS_MODES_LOADING,
	payload,
});

export const GET_ICEPACKS = 'thermoboxes-reports-modal/GET_ICEPACKS';
export const getIcepacksAction = () => ({
	type: GET_ICEPACKS,
});

export const SET_ICEPACKS = 'thermoboxes-reports-modal/SET_ICEPACKS';
export const setIcepacksAction = payload => ({
	type: SET_ICEPACKS,
	payload,
});

export const SET_IS_ICEPACKS_LOADING = 'thermoboxes-reports-modal/SET_IS_ICEPACKS_LOADING';
export const setIsIcepacksLoadingAction = payload => ({
	type: SET_IS_ICEPACKS_LOADING,
	payload,
});

export const GET_THERMOBOX_REPORT_DOCS = 'thermoboxes-reports-modal/GET_THERMOBOX_REPORT_DOCS';
export const getThermoboxReportDocsAction = payload => ({
	type: GET_THERMOBOX_REPORT_DOCS,
	payload,
});

export const SET_THERMOBOX_REPORT_DOCS = 'thermoboxes-reports-modal/SET_THERMOBOX_REPORT_DOCS';
export const setThermoboxReportDocsAction = payload => ({
	type: SET_THERMOBOX_REPORT_DOCS,
	payload,
});

export const POST_THERMOBOX_REPORT_DOCS = 'thermoboxes-reports-modal/POST_THERMOBOX_REPORT_DOCS';
export const postThermoboxReportDocsAction = payload => ({
	type: POST_THERMOBOX_REPORT_DOCS,
	payload,
});

export const SET_THERMOBOX_REPORT_DOCS_ERRORS = 'thermoboxes-reports-modal/SET_THERMOBOX_REPORT_DOCS_ERRORS';
export const setThermoboxReportDocsErrorsAction = payload => ({
	type: SET_THERMOBOX_REPORT_DOCS_ERRORS,
	payload,
});

export const SET_DOCS_FILES = 'thermoboxes-reports-modal/SET_DOCS_FILES';
export const setDocsFilesAction = payload => ({
	type: SET_DOCS_FILES,
	payload,
});

export const SET_IS_THERMOBOX_REPORT_DOCS_LOADING = 'thermoboxes-reports-modal/SET_IS_THERMOBOX_REPORT_DOCS_LOADING';
export const setIsThermoboxReportDocsLoadingAction = payload => ({
	type: SET_IS_THERMOBOX_REPORT_DOCS_LOADING,
	payload,
});

export const SET_IS_THERMOBOX_REPORT_DOCS_SENDING = 'thermoboxes-reports-modal/SET_IS_THERMOBOX_REPORT_DOCS_SENDING';
export const setIsThermoboxReportDocsSendingAction = payload => ({
	type: SET_IS_THERMOBOX_REPORT_DOCS_SENDING,
	payload,
});

export const GET_THERMOBOX_REPORT_FORM = 'thermoboxes-reports-modal/GET_THERMOBOX_REPORT_FORM';
export const getThermoboxReportFormAction = payload => ({
	type: GET_THERMOBOX_REPORT_FORM,
	payload,
});

export const SET_THERMOBOX_REPORT_FORM = 'thermoboxes-reports-modal/SET_THERMOBOX_REPORT_FORM';
export const setThermoboxReportFormAction = payload => ({
	type: SET_THERMOBOX_REPORT_FORM,
	payload,
});

export const RESET_STATE = 'thermoboxes-reports-modal/RESET_STATE';
export const resetThermoboxReportModalAction = () => ({
	type: RESET_STATE,
});
